// LIBRARIES

import styled from "styled-components";

//MISC

import { BORDER_RADIUS, DEVICE_TYPE } from "constants/variables";

export const NewsCardContainer = styled.div`
  width: 100%;
  height: auto;
  background-color: transparent;
  display: flex;
  flex-direction: column;
  gap: 16px;
  @media (max-width: ${DEVICE_TYPE.mobile}) {
    gap: 8px;
  }
`;

export const ImgCard = styled.img`
  border-radius: ${BORDER_RADIUS.radius24};
  width: 100%;
  margin-bottom: 8x;
  height: 264px;
  object-fit: cover;
  background-position: center;
  @media (max-width: ${DEVICE_TYPE.mobile}) {
    max-height: 165px;
  }
`;

export const TitleText = styled.div`
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
`;

export const PartnerName = styled.div`
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
`;

export const Subtitle = styled.div`
  display: flex;
  flex-direction: column;
`;

export const WrapperButton = styled.div`
  height: 42px;
  width: 129px;
`;
